const STORAGE_KEY = 'lp_participant_session_id';

function generateId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

let memoryFallback = null;

// A random id generated once per browser and persisted in localStorage (not sessionStorage —
// it must survive across tabs and reloads, not just the current tab). The backend uses this,
// not the display name, to identify "the same participant" — so two Anonymous participants (or
// two people who typed the same name) no longer collide and overwrite each other's response.
export function getParticipantSessionId() {
    try {
        let id = localStorage.getItem(STORAGE_KEY);
        if (!id) {
            id = generateId();
            localStorage.setItem(STORAGE_KEY, id);
        }
        return id;
    } catch {
        if (!memoryFallback) memoryFallback = generateId();
        return memoryFallback;
    }
}
